import { ConfigService } from './config.service';

/**
 * This is the provider for the config service.
 * It takes the config file in the environments folder and merges it into the config service at run time.
 * It overwrites all of the default values in the config file service, unless the config file doesn't have said value
 */
export const ConfigServiceFactory = () => {
  const config = new ConfigService();
  const browserWindow: any = window || {};
  const browserWindowConfig = browserWindow.__config || {};
  const win: any = window || {};

  for (const key in browserWindowConfig) {
    if (browserWindowConfig.hasOwnProperty(key)) {
      config[key] = win.__config[key];
    }
  }
  return config;
};

export const ConfigServiceProvider = {
  provide: ConfigService,
  useFactory: ConfigServiceFactory,
  deps: []
};
